module.exports = __webpack_public_path__ + "static/media/Heather Wilson Headshot.a44d5824.jpeg";